import { render, staticRenderFns } from "./paperDetail.vue?vue&type=template&id=3cd2f05e&scoped=true&"
import script from "./paperDetail.vue?vue&type=script&lang=js&"
export * from "./paperDetail.vue?vue&type=script&lang=js&"
import style0 from "./paperDetail.vue?vue&type=style&index=0&id=3cd2f05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd2f05e",
  null
  
)

export default component.exports